import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    orderHistoryLatest_loading: false,
    orderHistoryLatest_data: null,
    orderHistoryLatest_error: null,
    orderHistoryLatest_success: false
  };
  
const OrderHistoryLatestSlice = createSlice({
  name: 'OrderHistoryLatestSlice',
  initialState,
  reducers: {
    orderHistoryLatestServiceInit(state) {
      state.orderHistoryLatest_loading = true;
      state.orderHistoryLatest_error = null;
      state.orderHistoryLatest_data =  null;
      state.orderHistoryLatest_success = false;
    },
    orderHistoryLatestServiceSuccess(state, action) {
      state.orderHistoryLatest_loading = false;
      state.orderHistoryLatest_data = action.payload;
      state.orderHistoryLatest_success = true
    },
    orderHistoryLatestServiceFailure(state, action) {
      state.orderHistoryLatest_loading = false;
      state.orderHistoryLatest_error = action.payload;
      state.orderHistoryLatest_success = false
    }
  },
});

export const { 
  orderHistoryLatestServiceInit, 
  orderHistoryLatestServiceSuccess, 
  orderHistoryLatestServiceFailure
} = OrderHistoryLatestSlice.actions;

export default OrderHistoryLatestSlice.reducer;
